import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'pin-badge',
    templateUrl: './badge.component.html',
    imports: [MatIcon]
})
export class BadgeComponent {

  @Input()
  badgeClass: string;

  @Input()
  icon: string;

  @Input()
  text: string;
}
